<template>
  <div>
    <b-tabs v-if="group.hotels.length > 0">
      <b-tab v-for="hotel in group.hotels" :key="hotel.id" :title="hotel.hotelName" @click="getHotelRoomInfo(hotel.id)">
        <HotelTab
          v-if="!!group.groupHotelData && !isLoadingRooms"
          :groupData="group"
          :refreshData="getHotelRoomInfo"
          :hotelId="hotel.hotel"
        />
        <div v-else-if="isLoadingRooms" class="text-center p-2">
          <b-spinner variant="success"/> <br>
          Cargando información de habitaciones
        </div>
      </b-tab>
    </b-tabs>
    <div v-else>
      <b-alert show class="p-1" variant="warning">No se encontró información del grupo</b-alert>
    </div>
  </div>
</template>

<script>
import HotelTab from '@/modules/groups/components/GroupsList/HotelTab'
import { mapActions } from "vuex";

export default {
  components:{
    HotelTab
  },
  async mounted(){
    if (this.group.hotels.length > 0) await this.getHotelRoomInfo(this.group.hotels[0].id)
  },
  props:{
    group:{
      type: Object,
      required: true
    }
  },
  data(){
    return {
      roomsData: null,
      isLoadingRooms: false
    }
  },
  methods:{
    ...mapActions("groups", ["fetchGroupRooms"]),
    async getHotelRoomInfo(hotelGroupId){
      this.isLoadingRooms = true
      const groupHotelData = await this.fetchGroupRooms({id: hotelGroupId})
      this.group.groupHotelData = groupHotelData
      this.isLoadingRooms = false
      return groupHotelData
    }
  }
}
</script>

<style>

</style>